export default "__VITE_ASSET__D$hT$Iir__"